var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "#1C1C1C",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.263 2.047A.75.75 0 008.237.953c-1.345 1.261-3.355 3.27-5.02 4.957a544.248 544.248 0 00-2.77 2.826l-.236.242a.75.75 0 000 1.045l.236.241a518.572 518.572 0 002.77 2.825c1.665 1.687 3.675 3.697 5.02 4.958a.75.75 0 001.026-1.094c-1.322-1.239-3.312-3.23-4.98-4.917a544.348 544.348 0 01-2.122-2.162L1.796 9.5l.365-.374a543.16 543.16 0 012.122-2.161c1.668-1.689 3.658-3.679 4.98-4.918z",
    fill: "inherit"
  })));
}
export default SvgLeftArrow;